import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React from "react";
import ReactApexChart from "react-apexcharts";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

const EmployeeDashboard = ({ dashboardData }) => {
  const personalData = [
    {
      name: "General Compliance",
      value: 80,
      icon: <VerifiedUserOutlinedIcon fontSize="small" />,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
      color: "#A9B5FF",
    },
    {
      name: "Data Privacy",
      value: 40,
      icon: <StorageOutlinedIcon fontSize="small" />,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
      color: "#A9F0FF",
    },
    {
      name: "Workplace Safety",
      value: 34,
      icon: <WorkOutlineIcon fontSize="small" />,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
      color: "#A9F0FF",
    },
    {
      name: "Professional Development",
      value: 26,
      icon: <SchoolOutlinedIcon fontSize="small" />,
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ",
      color: "#FFD2A9",
    },
  ];

  const chartData = {
    series: [
      {
        name: "Phishing",
        data: [20, 30, 40, 30, 20],
      },
      {
        name: "Malware",
        data: [30, 20, 30, 40, 50],
      },
      {
        name: "Data Breaches",
        data: [40, 50, 20, 30, 40],
      },
      {
        name: "Ransomware",
        data: [50, 40, 50, 20, 30],
      },
    ],
    options: {
      chart: {
        type: "bar",
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "35px",
          borderRadius: 8, // Set border radius for each bar
          distributed: false,
        },
      },
      stroke: {
        width: 1,
        colors: ["#fff"],
      },

      legend: {
        position: "top",
        horizontalAlign: "right",
        offsetX: 40,
      },

      xaxis: {
        categories: [2020, 2021, 2022, 2023, 2024],
      },
      colors: ["#000000", "#9271F0", "#38DBFF", "#3B4BD9"],

      dataLabels: {
        enabled: false,
      },

      title: {
        text: "Security Trend",
        align: "left",
        floating: true,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#333",
        },
        offsetX: 10,
        offsetY: 10,
      },
    },
  };

  return (
    <>
      <Typography variant="h4" textAlign="left" mt={2}>
        Welcome{" "}
        {dashboardData?.userDetails?.name?.split(" ").slice(0, 2).join(" ")}
      </Typography>
      <Card sx={{ margin: "20px 0", borderRadius: "12px" }}>
        <Typography
          variant="h4"
          textAlign="left"
          sx={{ marginTop: "10px", marginLeft: "10px" }}
        >
          Personal Compliance
        </Typography>
        <CardContent sx={{ display: "flex", gap: "20px" }}>
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              borderRight: "2px solid #F1F1F1",
              paddingRight: "10px",
            }}
          >
            {personalData.map((val, i) => (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {/* Chart with the icon centered */}
                <Box
                  sx={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 !important",
                  }}
                >
                  <ReactApexChart
                    options={{
                      chart: {
                        type: "radialBar",
                      },
                      plotOptions: {
                        radialBar: {
                          hollow: {
                            size: "40%",
                          },
                          dataLabels: {
                            show: false,
                          },
                        },
                        track: {
                          strokeWidth: 90,
                        },
                      },
                      fill: {
                        type: "gradient",
                        gradient: {
                          shade: "dark",
                          type: "horizontal",
                          shadeIntensity: 0.5,
                          inverseColors: true,
                          opacityFrom: 1,
                          opacityTo: 1,
                          stops: [0, 100],
                        },
                      },
                    }}
                    series={[val.value]}
                    type="radialBar"
                    width={110}
                  />
                  {/* Icon inside the chart */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  >
                    {val.icon}
                  </Box>
                </Box>
                {/* Text display */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "left",
                  }}
                >
                  <Typography variant="body1" fontSize="14px">
                    {val.name}
                  </Typography>
                  <Typography variant="body2" fontSize="18px">
                    <b>{val.value}%</b>
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography
              variant="h5"
              textAlign="center"
              sx={{
                marginBottom: 1,
                fontSize: "15px",
                textAlign: "left",
                fontWeight: "bold",
              }}
            >
              Your compliance score
            </Typography>
            <Box>
              <ReactApexChart
                options={{
                  chart: {
                    type: "radialBar",
                  },
                  plotOptions: {
                    radialBar: {
                      hollow: {
                        size: "50%",
                      },
                      track: {
                        background: "#e0e0e0",
                        strokeWidth: 90,
                      },
                      dataLabels: {
                        name: {
                          show: false,
                        },
                        value: {
                          show: true,
                          fontSize: "22px",
                          //   offsetY: -5,
                        },
                      },
                    },
                  },
                  fill: {
                    type: "gradient",
                    gradient: {
                      shade: "dark",
                      type: "horizontal",
                      shadeIntensity: 0.5,
                      inverseColors: true,
                      opacityFrom: 1,
                      opacityTo: 1,
                      stops: [0, 100],
                    },
                  },
                }}
                series={[82]} // Updated to 82 to match the image
                type="radialBar"
                height={150}
              />
            </Box>
          </Box>
        </CardContent>
      </Card>
      <Grid container spacing={3} padding={2}>
        {/* Security Trend */}
        <Grid item xs={12} md={8}>
          <Card>
            <CardContent>
              <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type="bar"
                height={300}
              />
            </CardContent>
          </Card>
          <Card sx={{ marginTop: "20px", padding: "20px" }}>
            <Typography
              variant="h4"
              textAlign={"left"}
              mb={2}
              fontWeight={"bold"}
            >
              Quick Access
            </Typography>
            <Grid container spacing={2}>
              {[
                "Policy Library",
                "Training Modules",
                "Incident Reporting",
                "FAQs",
              ].map((quickAccess, index) => (
                <Grid item xs={12} md={3} key={index}>
                  <Card sx={{ minHeight: "180px" }}>
                    <CardContent>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        {/* Icon Placeholder */}
                      </Box>
                      <Typography variant="body1" textAlign="center">
                        {quickAccess}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Card>
        </Grid>

        {/* Pending Actions */}
        <Grid item xs={12} md={4}>
          <Card>
            <CardContent>
              <Typography variant="h5" textAlign={"left"} fontWeight={"bold"}>
                Pending Actions
              </Typography>
              <Box mt={2}>
                {personalData.map((val, index) => (
                  <Box
                    key={index}
                    display="flex"
                    // alignItems="center"
                    textAlign={"left"}
                    mb={6}
                  >
                    <Box
                      sx={{
                        background: val.color,
                        height: "fit-content",
                        padding: "15px",
                        borderRadius: "50%",
                        display: "flex",
                        alignContent: "center",
                      }}
                    >
                      {val.icon}
                    </Box>

                    <Box ml={2}>
                      <Typography variant="body1" fontWeight="bold">
                        {val.name}
                      </Typography>
                      <Typography variant="body2">{val.text}</Typography>
                    </Box>
                    <Box>
                      <KeyboardArrowRightOutlinedIcon />
                    </Box>
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Quick Access */}
      </Grid>
    </>
  );
};

export default EmployeeDashboard;
